import React, { useEffect, useState } from "react";
import MuiHeader from "../../components/MuiHeader";
import AodIcon from "@mui/icons-material/Aod";
import InfoIcon from "@mui/icons-material/Info";
import MoreVertIcon from "@mui/icons-material/MoreVert";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { blue } from "@mui/material/colors";
//mui
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  ListItemText,
  ListItemButton,
  TextField,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
} from "@mui/material";
import {
  createAllInstructionmasterModulewise,
  getAllInstructionsModulewise,
  updateInstructionsMaster,
} from "./InstructionThunk";
import MuiLoader from "../../components/MuiLoader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Instruction = () => {
  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------
  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedApp, setSelectedApp] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, app, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setSelectedApp(app);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedApp({});
  };
  // ---------------------------------------------
  //------------------Options for dropdowns-------->
  const instruction_module_select_option_list = [
    { value: "teacherbaseline", module: "Teacher Baseline" },
    { value: "teacherendline", module: "Teacher Endline" },
    { value: "pge", module: "PGE Activity" },
    { value: "ece", module: "ECE Activity" },
    { value: "nsdc", module: "NSDC" },
  ];

  //Set States for Get values
  const [isUpdate, setIsUpdate] = useState(false);
  const [module, setModule] = useState("");

  const [modalTitle, setModalTitle] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [instruction_heading, set_instructiuon_heading] = useState("");
  const [instruction, setInstruction] = useState([]);
  ////console.log("instruction--->", instruction);
  const [instruction_note, set_instruction_note] = useState("");
  const [get_instructions, set_get_instructions] = useState([]);
  // //console.log(
  //   "get_instructions---->",
  //   get_instructions,
  //   get_instructions.length
  // );
  const [instructionId, setInstructionId] = useState("");
  // //console.log("instructionId--->", instructionId);
  const [updateInstructions, setUpdateInstructions] = useState([]);

  //Onchange Functions for set Values to their corresponding state
  const inputArr = [
    {
      instructionId: new Date().getTime(),
      instruction: "",
      value: "",
    },
  ];

  const [arr, setArr] = useState(inputArr);
  ////console.log("arr---->", arr);
  const addInput = () => {
    setArr((s) => {
      return [
        ...s,
        {
          instructionId: new Date().getTime(),
          instruction: "",
          value: "",
        },
      ];
    });
  };
  // //console.log("handlechange--->", arr);
  const handleChange = (e) => {
    e.preventDefault();

    const index = e.target.id;
    setArr((s) => {
      const newArr = s.slice();
      newArr[index].value = e.target.value;

      newArr[index].instruction = e.target.value;
      return newArr;
    });
  };

  const module_select_onchange = (event) => {
    setModule(event.target.value);
    getAllInstructionsModulewise(event.target.value).then((response) => {
      ////console.log("get response--->", response.data);
      set_get_instructions(response.data);
    });
  };

  //For Create Instructions Modal
  const create_app_button_click = () => {
    // cleardata();
    setModalTitle("New Instructions Details");

    {
      get_instructions.length > 0
        ? alert("Instruction already Created")
        : setOpenModal(true);
    }
  };

  const modal_cancle_button_click = () => {
    setOpenModal(false);
    set_instructiuon_heading("");
    setInstruction("");
    set_instruction_note("");
    setArr(inputArr);
  };

  //For Update Instruction Modal
  const update_app_button_click = (params) => {
    // //console.log("params--->", params);
    setUpdateInstructions(params);
    setIsUpdate(true);
    setModalTitle("Update Instruction Details");
    setInstructionId(params.instructionsData[0].instructionId);
    set_instructiuon_heading(params.instructionHeading);
    setInstruction(params.instructionsData);
    setArr(params.instructionsData);
    set_instruction_note(params.instructionNote);
    setModule(params.module);
    setOpenModal(true);
    handleVertMenuClose();
  };

  //For Save Instruction Modal
  const modal_save_button_click = () => {
    ////console.log("isUpdate: ", isUpdate);
    if (
      instruction_heading === undefined ||
      instruction_heading === null ||
      instruction_heading.length <= 0
    )
      toast.error("Enter Instruction Heading");
    else if (arr === undefined || arr === null || arr.length <= 0)
      toast.error("Enter Instructions");
    else if (
      instruction_note === undefined ||
      instruction_note === null ||
      instruction_note.length <= 0
    )
      toast.error("Enter Instruction Notes");
    else {
      if (isUpdate === true) updatedata();
      else savedata();
      setOpenModal(false);
    }
  };

  const savedata = () => {
    const data = {
      module: module,
      instructionHeading: instruction_heading,
      instructionsData: arr,
      // instructionsData: instruction,
      instructionNote: instruction_note,
    };
    ////console.log("data----->", data);

    createAllInstructionmasterModulewise(data).then((response) => {
      ////console.log(response.data);
      if (response.data.status == "success") {
        toast.success("Instruction added successfully!");
        getAllInstructionsModulewise(module).then((response) => {
          //   //console.log("get response--->", response);
          set_get_instructions(response.data);
          setOpenModal(false);
          set_instructiuon_heading("");
          setInstruction("");
          set_instruction_note("");
        });
      }
    });
  };

  const updatedata = () => {
    // //console.log("selectedApp-->", updateInstructions);
    // const data = {
    //   module: module,
    //   instructionHeading: instruction_heading,
    //   instructionsData: {
    //     instructionId: instructionId,
    //     instruction: instruction,
    //   },
    //   instructionNote: instruction_note,
    // };
    const data = {
      module: module,
      instructionHeading: instruction_heading,
      instructionsData: arr,
      instructionNote: instruction_note,
    };
    ////console.log("update data---->", data);
    updateInstructionsMaster(data).then((response) => {
      // //console.log("update response-->", response.data);
      if (response.data.status == "success") {
        toast.success("Instruction Updated successfully!");
        getAllInstructionsModulewise(module).then((response) => {
          //   //console.log("get response--->", response);
          set_get_instructions(response.data);
          setOpenModal(false);
          set_instructiuon_heading("");
          setInstruction("");
          set_instruction_note("");
        });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="Instruction Master" />
        <FormControl
          style={{ marginTop: 73 }}
          sx={{ m: 1, minWidth: 120 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Modules</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={module}
            label="module"
            onChange={module_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {instruction_module_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.module}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={create_app_button_click}
          variant="contained"
          disabled={module.length > 0 ? false : true}
        >
          Create New
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {get_instructions.length > 0 ? (
              <>
                {get_instructions.map((app, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={isSmallScreen ? 12 : 6}
                    md={4}
                    key={index}
                  >
                    <Card sx={{ maxWidth: 345 }}>
                      <CardHeader
                        avatar={
                          <Avatar sx={{ bgcolor: blue[500] }}>
                            <InfoIcon />
                          </Avatar>
                        }
                        action={
                          <>
                            <IconButton
                              id={index + 1.1}
                              onClick={(e) =>
                                handleVertMenuClick(e, app, index)
                              }
                              aria-controls={
                                openVertMenu ? { index } : undefined
                              }
                              aria-expanded={openVertMenu ? "true" : undefined}
                              aria-haspopup="true"
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </>
                        }
                        title={
                          <div style={{ cursor: "pointer", wordBreak: "break-all" }}>
                            {app.instructionHeading}
                          </div>
                        }
                        subheader={
                          <>
                            <div style={{ cursor: "pointer",  wordBreak: "break-all" }}>
                              {app.instructionsData[0].instruction
                                ? app.instructionsData.map((x, i) => (
                                    <div>
                                      {i + 1} . {x.instruction}
                                    </div>
                                  ))
                                : ""}
                            </div>
                            <div style={{ cursor: "pointer", marginTop: 12 ,  wordBreak: "break-all"}}>
                              {app.instructionNote ? app.instructionNote : ""}
                            </div>
                          </>
                        }
                      />
                      {/* <CardMedia component="img" height="194" image={require("../../media/images/content.webp")} alt="content" />
                  <CardContent></CardContent> */}
                    </Card>
                  </Grid>
                ))}

                <Menu
                  id={selectedIndex}
                  anchorEl={anchorEl}
                  open={openVertMenu}
                  onClose={handleVertMenuClose}
                  MenuListProps={{
                    "aria-labelledby": "vert-button",
                  }}
                  PaperProps={{
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      width: "20ch",
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => update_app_button_click(selectedApp)}
                  >
                    Edit
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <h1></h1>
            )}
          </Grid>
        </Box>
      </div>
      <ToastContainer />
      {/* save or update modal */}
      <Dialog
        open={openModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={modal_cancle_button_click}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent>
          <TextField
            // disabled={disableAppname}
            id="instructionheading"
            label="Instruction Heading"
            name="instructionheading"
            value={instruction_heading}
            onChange={(e) => set_instructiuon_heading(e.target.value)}
            autoComplete="instructionheading"
            margin="normal"
            required
            fullWidth
            autoFocus
          />

          {arr.map((item, i) => {
            ////console.log("item--->", item);
            return (
              <TextField
                id={i}
                label="Instruction"
                name="instruction"
                value={item.instruction}
                //onChange={(e) => setInstruction(e.target.value)}
                onChange={handleChange}
                autoComplete="instruction"
                margin="normal"
                required
                fullWidth
                autoFocus
              />
            );
          })}

          <Button
            className="button__addField"
            type="button"
            variant="contained"
            onClick={addInput}
          >
            Add Instructions
          </Button>
          <TextField
            id="instructionnote"
            label="Instruction Note"
            name="instructionnote"
            value={instruction_note}
            onChange={(e) => set_instruction_note(e.target.value)}
            autoComplete="instructionnote"
            margin="normal"
            required
            fullWidth
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={modal_cancle_button_click}>Cancel</Button>
          <Button onClick={modal_save_button_click}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Instruction;
